export const baseurl = window.env.REACT_APP_BASE_URL;

// export const baseurl = "http://127.0.0.1:8000/api";

// export const baseurl = "https://dev-api.aegis-360.ai/api";

export const endpoints = {
  CHECKEMAIL: "/auth/checkEmail?email=",
  LOGIN: "/auth/login",
  DASHBOARD_TABS: "/dashboard/tabs",
  DASHBOARD_ORGANISATIONS: "/dashboard/organisations",
  DASHBOARD_SUPERADMIN: "/dashboard/superadmin/",
  DASHBOARD_ADMIN: "/dashboard/admin/",
  DASHBOARD_AI_FEEDBACK: "/dashboard/ai-feedback",
  SEND_OTP: "/auth/sendOtp?email=",
  VERIFY_OTP: "/auth/verifyOtp",
  FORGOT_PASSWORD: "/auth/generatePasswordLink?email=",
  CHECKVALIDITY: "/auth/checkLinkValidity",
  UPDATE_PASSWORD: "/auth/updatePassword",
  SAVE_CLIENT: "/clients/saveClient",
  GET_CLIENTS: "/clients/getAllClients",
  GET_CLIENT_LOGO: "/clients/getClientLogo/",
  GET_CLIENT_BY_ID: "/clients/getClientById/",
  GET_ALL_CLIENT_NAMES: "/clients/getClientsNames",
  DELETE_CLIENT: "/clients/deleteClient/",
  GET_AUDIT_LOGS: "/auditlogs/getAllLogs",
  GET_AUDIT_100_LOGS: "/auditlogs/get100Logs",
  GET_AUDIT_BY_ID: "/auditlogs/getAuditById/",
  GET_SUBSCRIPTIONS: "/subscriptions/getAllSubscriptions",
  GET_SUBSCRIPTION_BY_ID: "/subscriptions/getSubscriptionById/",
  GET_ALL_PLANS_PRICES: "/subscriptions/getAllPlanPrices",
  DELETE_SUBSCRIPTION: "/subscriptions/deleteSubscription/",
  SAVE_SUBSCRIPTION: "/subscriptions/createSubscription",
  GET_ALL_SUBSCRIBERS: "/subscriptions/getAllSubscribers",
  GET_SUBSCRIBER_BY_ID: "/subscriptions/getSubscriberById/",
  CREATE_PAYMENT_LINK: "/subscriptions/createPaymentLink",
  GET_TRANSACTIONS: "/subscriptions/getAllTransactionDetails/",
  DOWNLOAD_INVOICE: "/subscriptions/downloadInvoice/",
  CANCEL_SUBSCRIPTION: "/subscriptions/cancelSubscription/",
  SUBSCRIPTION_CONFIRMATION: "/subscriptions/getSubscriptionConfirmation/",
  GET_ALL_ROLES: "/roles/getAllRoles",
  GET_ROLE_BY_ID: "/roles/getRoleById/",
  SAVE_ROLE: "/roles/saveRole",
  GET_ALL_PERMISSIONS: "/roles/getAllPermissions",
  DELETE_ROLE: "/roles/deleteRole/",
  GET_ROLES_NAMES: "/roles/getRolesNames",
  GET_USERS: "/users/getAllUsers",
  GET_USER_BY_ID: "/users/getUserById/",
  SAVE_USER: "/users/saveUser",
  DELETE_USER: "/users/deleteUser/",
  GET_ALL_DOCTORS: "/doctors/getAllDoctors",
  DELETE_DOCTOR: "/doctors/deleteDoctor/",
  GET_SCHEDULES: "/doctors/getDoctorSchedule/",
  GET_DOCTOR_BY_ID: "/doctors/getDoctorById/",
  GET_DAYS_OFF: "/doctors/getDoctorDaysOff/",
  SAVE_DOCTOR_SCHEDULE: "/doctors/saveDoctorSchedule",
  SAVE_DOCTOR_DAYS_OFF: "/doctors/saveDoctorDayOff",
  DELETE_DOCTOR_SCHEDULE: "/doctors/deleteDoctorSchedule/",
  DELETE_DOCTOR_DAYS_OFF: "/doctors/deleteDoctorDayOff/",
  GET_ALL_SERVICES: "/services/getAllServices",
  GET_SERVICE_BY_ID: "/services/getServiceById/",
  SAVE_SERVICES: "/services/saveService",
  DELETE_SERVICE: "/services/deleteServiceById/",
  CARE_AI_RESPONSE: "/careai/generateQuestions",
  CARE_AI_PROCEDURE: "/rag/generateProcedure",
  CODING_AI_GENERATE_CODES: "/medicalcoding/generateCodes",
  CODING_AI_ASSISTANT_CHAT: "/medicalcoding/assistant/chat",
  EMAIL_TEMPLATES: "/emailtemplates/getAllEmailTemplatesAccount",
  GET_EMAIL_TEMPLATE_BY_ID: "/emailtemplates/getEmailTemplateById/",
  SAVE_EMAIL_TEMPLATE: "/emailtemplates/saveEmailTemplate",
  DELETE_EMAIL_TEMPLATE: "/emailtemplates/deleteEmailTemplate/",
  GET_ALL_CONTENT_TYPES: "/emailtemplates/getAllContentTypes",
  GET_ALL_POS_LIST: "/organization/getAllPOSList",
  SAVE_ORGANIZATION: "/organization/saveOrganization",
  VALIDATE_NPI: "/organization/getOrganizationDetailsByNPI?npi=",
  UPLOAD_ORG_DOCS: "/organization/uploadOrganizationDocument",
  GET_ALL_ORGANIZATIONS: "/organization/getAllOrganizations",
  GET_ALL_ORGANIZATION_NAMES: "/organization/getOrganizationNames",
  GET_ORGANIZATION_BY_ID: "/organization/getOrganizationById?organization_id=",
  GET_ALL_DOCUMENTS_BY_ORG_ID: "/organization/getAllOrganizationDocuments?organization_id=",
  DELETE_ORGANIZATION: "/organization/deleteOrganization?organization_id=",
  GET_DOCUMENT_BY_ID: "/organization/getdocumentById?document_id=",
  DELETE_DOCUMENT_BY_ID: "/organization/deleteDocument?document_id=",
  SAVE_ORG_TRANSITION: "/organization/saveOrganizationTransition",
  GET_ORG_TRANSITION_BY_ORG_ID: "/organization/getOrganizationTransitions?organization_id=",
  GET_ORG_SOP: "/organization/getOrganizationSOP?organization_id=",
  SAVE_SOP: "/organization/saveOrganizationSOP",
  SAVE_ORG_REPORTS: "/organization/saveOrganizationReport",
  GET_ALL_ORG_REPORTS: "/organization/getAllOrganizationReports?organization_id=",
  GET_ORG_REPORT_BY_ID: "/organization/getOrganizationReportById?report_id=",
  DELETE_ORG_REPORT_BY_ID: "/organization/deleteOrganizationReport?report_id=",
  DOWNLOAD_ORG_DOCUMENT: "/organization/downloadOrganizationDocument?file_id=",
  GET_ALL_LOCATIONS: "/locations/getAllLocations",
  GET_LOCATION_BY_ID: "/locations/getLocationById?location_id=",
  GET_LOCATION_BY_ORG_ID: "/locations/getLocationByOrgId?org_id=",
  SAVE_LOCATION: "/locations/saveLocation",
  DELETE_LOCATION: "/locations/deleteLocation?location_id=",
  GET_ALL_STAFFS: "/staff/getAllStaff",
  GET_ALL_STAFF_NAMES: "/staff/getAllStaffNames",
  GET_STAFF_BY_ID: "/staff/getStaffById?staff_id=",
  SAVE_STAFF: "/staff/saveStaff",
  DELETE_STAFF: "/staff/deleteStaff?staff_id=",
  SAVE_LOGIN_CREDS: "/logincreds/saveLoginCreds",
  GET_ALL_LOGIN_CREDS: "/logincreds/getAllLoginCreds",
  GET_LOGIN_CREDS_BY_ID: "/logincreds/getLoginCredsById/",
  DELETE_LOGIN_CREDS: "/logincreds/deleteLoginCreds/",
  LOAD_TITLES: "/logincreds/loadTitles",
  GET_REPORT_AUTOMATIONS: "/scripts/getReportAutomations",
  GET_REPORT_LOGINS: "/scripts/getReportLogins?automation=",
  GET_REPORT_RUNS: "/scripts/getReportRuns",
  RUN_REPORT: "/scripts/runReport",
  GET_ALL_PROVIDER_SETTING: "/providers/getAllSettings?type=",
  SAVE_PROVIDER: "/providers/saveProviders",
  GET_ALL_PROVIDERS: "/providers/getAllProviders",
  GET_PROVIDERS_BY_ID: "/providers/getProviderById?provider_id=",
  SAVE_PROVIDER_EDUCATION: "/providers/saveProviderEducation",
  GET_ALL_PROVIDER_EDUCATIONS: "/providers/getAllProviderEducations?provider_id=",
  GET_PROVIDER_EDUCATION_BY_ID: "/providers/getProviderEducationById?education_id=",
  DELETE_PROVIDER_EDUCATION: "/providers/deleteProviderEducation?education_id=",
  SAVE_PROVIDER_EXAM: "/providers/saveProviderExams",
  GET_ALL_PROVIDERS_EXAMS: "/providers/getAllProviderExams?provider_id=",
  GET_PROVIDER_EXAM_BY_ID: "/providers/getProviderExamsById?exam_id=",
  DELETE_PROVIDER_EXAM: "/providers/deleteProviderExam?exam_id=",
  SAVE_PROVIDER_EMPLOYER: "/providers/saveProviderEmployers",
  GET_PROVIDER_EMPLOYER_BY_ID: "/providers/getProviderEmployersById?employer_id=",
  GET_ALL_PROVIDER_EMPLOYERS: "/providers/getAllProviderEmployers?provider_id=",
  DELETE_PROVIDER_EMPLOYER: "/providers/deleteProviderEmployers?employer_id=",
  SAVE_PROVIDER_FACILITY: "/providers/saveProviderAffiliation",
  GET_PROVIDER_FACILITY_BY_ID: "/providers/getProviderAffiliationById?affiliation_id=",
  GET_ALL_PROVIDER_FACILITIES: "/providers/getAllProviderAffiliation?provider_id=",
  DELETE_PROVIDER_FACILITY: "/providers/deleteProviderAffiliation?affiliation_id=",
  SAVE_PROVIDER_WORK_HISTORY: "/providers/saveProviderWorkHistory",
  GET_ALL_PROVIDER_WORK_HISTORY: "/providers/getAllProviderWorkHistory?provider_id=",
  GET_PROVIDER_WORK_HISTORY_BY_ID: "/providers/getProviderWorkHistoryById?work_history_id=",
  DELETE_PROVIDER_WORK_HISTORY: "/providers/deleteProviderWorkHistory?work_history_id=",
  SAVE_PROVIDER_MILITARY: "/providers/saveProviderMilitaryExperience",
  GET_ALL_PROVIDER_MILITARY: "/providers/getAllProviderMiltaryExperience?provider_id=",
  GET_PROVIDER_MILITARY_BY_ID: "/providers/getProviderMilitaryExperienceById?military_experience_id=",
  DELETE_PROVIDER_MILITARY: "/providers/deleteProviderMilitaryExperience?military_experience_id=",
  SAVE_PROVIDER_PEER_REFERENCE: "/providers/saveProviderPeerRef",
  GET_ALL_PROVIDER_PEER_REFERENCE: "/providers/getAllProviderPeerRef?provider_id=",
  GET_PROVIDER_PEER_REFERENCE_BY_ID: "/providers/getProviderPeerRefById?peer_ref_id=",
  DELETE_PROVIDER_PEER_REFERENCE: "/providers/deleteProviderPeerRef?peer_ref_id=",
  SAVE_PROVIDER_HEALTH_INFO: "/providers/saveProviderHealthInfo",
  GET_ALL_PROVIDER_HEALTH_INFO: "/providers/getAllProviderHealthInfo?provider_id=",
  GET_PROVIDER_HEALTH_INFO_BY_ID: "/providers/getProviderHealthInfoById?health_info_id=",
  DELETE_PROVIDER_HEALTH_INFO: "/providers/deleteProviderHealthInfo?health_info_id=",
  SAVE_PROVIDER_MALPRACTICE: "/providers/saveProviderMalpractice",
  GET_ALL_PROVIDER_MALPRACTICE: "/providers/getAllProviderMalpractice?provider_id=",
  GET_PROVIDER_MALPRACTICE_BY_ID: "/providers/getProviderMalpracticeById?malpractice_id=",
  DELETE_PROVIDER_MALPRACTICE: "/providers/deleteProviderMalpractice?malpractice_id=",
  SAVE_PROVIDER_EVENT_LOG: "/providers/saveProviderEventLog",
  GET_ALL_PROVIDER_EVENT_LOG: "/providers/getAllProviderEventLogs?provider_id=",
  GET_PROVIDER_EVENT_LOG_BY_ID: "/providers/getProviderEventLogById?event_log_id=",
  DELETE_PROVIDER_EVENT_LOG: "/providers/deleteProviderEventLog?event_log_id=",
  SAVE_PROVIDER_LICENSE: "/providers/saveProviderLicense",
  GET_PROVIDER_LICENSE_BY_ID: "/providers/getProviderLicenseById?license_id=",
  GET_ALL_STATE_LICENSES: "/providers/getAllProviderStateLicense?provider_id=",
  GET_ALL_DEAL_LICENSES: "/providers/getAllProviderDEALicense?provider_id=",
  GET_ALL_CONTROLLED_SUBSTANCE_LICENSES: "/providers/getAllProviderStateControlledSubstanceLicense?provider_id=",
  DELETE_PROVIDER_LICENSE: "/providers/deleteProviderLicense?license_id=",
  SAVE_PROVIDER_CERTIFICATES: "/providers/saveProviderCertificate",
  GET_PROVIDER_CERTIFICATES_BY_ID: "/providers/getProviderCertificateById?certificate_id=",
  GET_ALL_PROVIDER_BOARDS: "/providers/getAllProviderBoard?provider_id=",
  GET_ALL_PROVIDER_PROFESSIONAL: "/providers/getAllProviderProfessional?provider_id=",
  GET_ALL_PROVIDER_ADDITIONAL: "/providers/getAllProviderAdditional?provider_id=",
  DELETE_PROVIDER_CERTIFICATES: "/providers/deleteProviderCertificate?certificate_id=",
  PREVIEW_PROVIDER_FILE: "/providers/previewProviderFile?file_id=",
  DOWNLOAD_PROVIDER_FILE: "/providers/downloadProviderFile?file_id=",
  GET_ALL_PROVIDER_NAMES: "/providers/getAllProviderNames",
  GET_ALL_HEALTHCARE_PAYORS: "/providers/getAllProviderHealthCarePayors",
  GET_HEALTHCARE_PAYOR_BY_ID: "/providers/getProviderHealthCarePayorById?healthcarepayor_id=",
  SAVE_HEALTHCARE_PAYOR: "/providers/saveProviderHealthCarePayor",
  DELETE_HEALTHCARE_PAYOR: "/providers/deleteProviderHealthCarePayor?healthcarepayor_id=",
  GET_ALL_HEALTHCARE_NOTES: "/providers/getAllHealthCareNotes?healthcarepayor_id=",
  SAVE_HEALTHCARE_NOTES: "/providers/saveHealthCareNote",
  DELETE_PROVIDER: "/providers/deleteProvider?provider_id=",
  GET_PROVIDER_NPI: "/providers/getProviderDetailByNPI?npi=",
  GET_ORG_MEMBERS: "/organization/getMembersByOrganizationId?organization_id=",
  GET_ORG_MEMBER_DETAILS: "/organization/getOrganizationAllMembers?org_id=",
  SAVE_TRACKING: "/tracking/saveTracking",
  GET_TRACKING_BY_ID: "/tracking/getTrackingById/",
  GET_ALL_TRACKING: "/tracking/getAllTrackings",
  DELETE_TRACKING: "/tracking/deleteTracking/",
  GET_ALL_FOLLOW_UPS: "/tracking/getAllFollowUps",
  GET_ORG_ANALYTICS: "/analytics/getAllProductivityAnalytics?organization_id=",
  GET_ALL_ORG_ANALYTICS: "/analytics/getAllOrganizationAnalytics",
  GET_ORG_ANALYTICS_BY_DATE: "/analytics/getOrganizationAnalyticsByDates?start_date={start_date}&end_date={end_date}&facility_name={facility_name}",
  GET_ALL_ORG_PRODUCTIVITY: "/analytics/getAllProductivityAnalytics?organization_id={organization_id}&start_date={start_date}&end_date={end_date}",
  GET_ALL_ORG_PATIENTS: "/analytics/getPatientAnalytics?organization_id={organization_id}&start_date={start_date}&end_date={end_date}",
  GET_ALL_PATIENT: "/analytics/getAllPatientAnalytics",
  GET_ALL_PROVIDER_PRODUCTIVITY: "/analytics/getAllProviderProductivityAnalytics",
  GET_PROVIDER_PRODUCTIVITY_LIST: "/analytics/getProviderProductivityList?organization_id={organization_id}",
  GET_PROVIDER_ANALYTICS: "/analytics/getProviderAnalytics?organization_id={organization_id}&provider_name={provider_name}",
  GET_PROVIDER_ANALYTICS_TREND: "/analytics/getProviderAnalyticsTrend?organization_id={organization_id}&provider_name={provider_name}",
  GET_PROVIDER_BENCHMARK: "/analytics/getProviderBenchmark?organization_id={organization_id}&provider_name={provider_name}",
  GET_ORGANIZATIONS_REVENUE: "/analytics/getOrganizationsRevenue",
  GET_ORGANIZATION_REVENUE: "/analytics/getOrganizationRevenue?organization_id={organization_id}&start_date={start_date}&end_date={end_date}",
  ANALYTICS_CHAT: "/analytics/chat",
  ANALYTICS_CHAT_SUMMARY_EMAIL: "/analytics/chat/summary-email",
  GET_VALUE_BASED_CARE_ORGANIZATIONS: "/valuebasedcare/getOrganizations",
  GET_VALUE_BASED_CARE_ANALYTICS: "/valuebasedcare/getAnalytics",
  GET_VALUE_BASED_CARE_FILTERS: "/valuebasedcare/getFilterOptions",
  GET_FEE_SCHEDULE_PAYERS: "/feeschedule/getAllPayerAnalytics",
  GET_FEE_SCHEDULE_OVERVIEW: "/feeschedule/getPayerOverview",
  GET_FEE_SCHEDULE_NETWORK_PLANS: "/feeschedule/getNetworkPlans",
  GET_FEE_SCHEDULE_ZIP_RATES: "/feeschedule/getZipProviderRates",
  GET_FEE_SCHEDULE_PROVIDER_RATES: "/feeschedule/getProviderRateCard",
  GET_FEE_SCHEDULE_MY_RATE_CARD: "/feeschedule/getMyRateCard",
  GET_FEE_SCHEDULE_SPECIALTIES: "/feeschedule/getSpecialties",
  GET_FEE_SCHEDULE_SPECIALTY_RATES: "/feeschedule/getSpecialtyProviderRates",
  GET_FEE_SCHEDULE_GROUP_RATES: "/feeschedule/getGroupRates",
  GET_FEE_SCHEDULE_EXPIRING_RATES: "/feeschedule/getExpiringRates",
  GET_FEE_SCHEDULE_DATA_QUALITY: "/feeschedule/getDataQuality",
  FEE_SCHEDULE_CHAT: "/feeschedule/chat",
  FEE_SCHEDULE_CHAT_SUMMARY_EMAIL: "/feeschedule/chat/summary-email",
  GET_ALL_NOTIFICATIONS: "/notification/getAllNotifications",
  MARK_NOTIFICATIONS_READ: "/notification/markAsRead",
  MARK_NOTIFICATIONS_UNREAD: "/notification/markAsUnread",
  MARK_ALL_NOTIFICATIONS_READ: "/notification/markAllAsRead",
  DELETE_NOTIFICATIONS: "/notification/deleteNotifications",
  SAVE_INCENTIVE_RATE: "/incentiverate/saveIncentiveRate",
  GET_ALL_INCENTIVE_RATES_FOR_ACCOUNT: "/incentiverate/getAllIncentiveRates",
  GET_ALL_INCENTIVE_RATES: "/incentiverate/getAllIncentiveRates/",
  GET_INCENTIVE_RATE_BY_ID: "/incentiverate/getIncentiveRateById/",
  DELETE_INCENTIVE_RATE: "/incentiverate/deleteIncentiveRate/",
  LOAD_INCENTIVE_INSURANCES: "/incentiverate/loadInsurances/",
  LOAD_INCENTIVE_CPT_CODES: "/incentiverate/loadCptCodes/",
  LOAD_INCENTIVE_FACILITIES: "/incentiverate/loadFacilities/",
  GET_PROVIDER_INCENTIVE_REPORT: "/payroll/getProviderIncentiveReport/",
  GET_ELIGIBILIT: "/stedi/eligibility-logs",
  GET_ELIGIBILITY_LIST: "/stedi/eligibility-logs/{verification_id}",
  POST_ELIGIBILITY: "/stedi/eligibility",
  POST_BULK_ELIGIBILITY: "/stedi/bulk/eligibility",
  POST_BULK_CLAIM_STATUS: "/stedi/bulk/claim-status",
  GET_BULK_TEMPLATE: "/stedi/bulk/template/",
  POST_REFRESH_BATCH_ELIGIBILITY: "/stedi/batch-eligibility/refresh",
  UPLOAD_EXCEL_ELIGIBILITY: "/stedi/upload-excel",
  GET_CLAIMSTATUS: "/stedi/claim-status-logs",
  GET_CLAIMSTATUS_LIST: "/stedi/claim-status-logs/{record_id}",
  POST_CLAIM_STATUS: "/stedi/claim-status",
  GET_DENIED_CLAIMS: "/denials",
  GET_ALL_PAYERS: "/stedi/getAllPayers",
  GET_ORGANIZATION_PROVIDERS: "/stedi/organization-providers",
  GET_INSURANCE_LIST: "/stedi/insurance-list",
  GET_CLAIMSUBISSION: "/claims/drafts",
  GET_CLAIMSUBISSION_LIST: "/claims/drafts/visitId={visitId}",
  GET_ALL_AEGIS_AI_DOCUMENTS: "/aegisai/documents/getAllDocuments",
  GET_AEGIS_AI_DOCUMENT_BY_ID: "/aegisai/documents/getDocumentById/",
  SAVE_AEGIS_AI_DOCUMENT: "/aegisai/documents/saveDocument",
  DELETE_AEGIS_AI_DOCUMENT: "/aegisai/documents/deleteDocumentById/",
  EXTRACT_AEGIS_AI_SOURCE_STREAM: "/aegisai/documents/extractStream",
  SUMMARIZE_AEGIS_AI_WEBSITE_STREAM: "/aegisai/documents/summarizeWebsiteStream",
  GET_AEGIS_AI_YOUTUBE_PREVIEW: "/aegisai/documents/youtubePreview?url=",
  GET_AEGIS_AI_DOCUMENT_MEDIA: "/aegisai/documents/getDocumentMedia/",
  REVIEW_AEGIS_AI_HALLUCINATION_RISKS: "/aegisai/documents/reviewHallucinationRisks",
  CLEAN_AEGIS_AI_TRANSCRIPT: "/aegisai/documents/cleanTranscript",
  GET_AEGIS_AI_DOCUMENT_HTML: "/aegisai/documents/documentHtml",
  GET_ALL_AEGIS_AI_ASSIST_CONFIGS: "/aegisai/assist/getAllAssistConfigs",
  GET_AEGIS_AI_ASSIST_CONFIG_BY_ID: "/aegisai/assist/getAssistConfigById/",
  SAVE_AEGIS_AI_ASSIST_CONFIG: "/aegisai/assist/saveAssistConfig",
  DELETE_AEGIS_AI_ASSIST_CONFIG: "/aegisai/assist/deleteAssistConfigById/",
  UPLOAD_AEGIS_AI_ASSIST_ICON: "/aegisai/assist/uploadAssistIcon/",
  REMOVE_AEGIS_AI_ASSIST_ICON: "/aegisai/assist/removeAssistIcon/",
  AEGIS_AI_PUBLIC_ASSIST: "/aegisai/public/assist/",
  AEGIS_AI_CHAT_SEND_MESSAGE: "/aegisai/chat/sendMessage",
  AEGIS_AI_CHAT_SEND_MESSAGE_STREAM: "/aegisai/chat/sendMessageStream",
  AEGIS_AI_CHAT_CLEAR_SESSION: "/aegisai/chat/clearSession",
  AEGIS_AI_TEAMS_CHAT_STREAM: "/aegisai/teams/chatStream",
  AEGIS_AI_TEAMS_CLEAR_SESSION: "/aegisai/teams/clearSession",
}